import React, { useState } from 'react';
import { Input, Button, Spin } from 'antd';
import MainMenu from 'components/mainMenu';

import './index.scss';
import requestAPI from 'helpers/requestAPI';
import { toastError, toastWarning, toastSuccess } from 'utils/toastr';

const ChangeIp = () => {
    const [ ip, setIp ] = useState('');
    const [ isSpinning, setIsSpinning ] = useState(false);

    const onChangeIp = (e) => {
        setIp(e.target.value)
    }

    const getCurrentIp = async () => {
        const params = {
            routeParams: {
                route: 'change_office_ip'
            }
        }

        setIsSpinning(true);

        await requestAPI(params).then((response) => {
            setIp(response.data.data.ip);
        }).catch(err => {
            toastError(err);
        });

        setIsSpinning(false);
    }

    const changeIpAdress = async () => {
        if(!ip.trim()) {
            toastWarning('Enter ip adress');
            return
        }

        if(!/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(ip)) {
            toastWarning('Invlid ip adress');
            return
        }

        const changeParam = {
            routeParams: {
                route: 'change_office_ip'
            },
            method: 'PUT',
            data: {
                new_ip: ip
            }
        };

        setIsSpinning(true);

        await requestAPI(changeParam).then(() => {
            toastSuccess('Done');
            setIp('');
        }).catch(err => {
            toastError('Error');
        });

        setIsSpinning(false);
    }

    return (
        <div>
            <MainMenu />

            <div className="change-ip-wrapper">
                <Spin spinning={isSpinning}>
                    <Input value={ip} type='' onChange={onChangeIp} />
                </Spin>
                <div className="change-ip__btns">
                    <Button onClick={getCurrentIp} type="primary">Get current address</Button>
                    <Button onClick={changeIpAdress} type="danger" className="change-ip__btns__change-btn">Change adress</Button>
                </div>
            </div>
        </div>
    )
}

export default ChangeIp;